
import './CSS/border.scss';
import MatBorder from './Assets/MAT-border.svg'

export default function Border()
{
    return (
        <div className='Page'>
            <h1>Couleur du border</h1>

            <p>Voilà nous y sommes, nous allons enfin faire quelque chose de concret. A savoir : changer la couleur du bord.</p>

            <p>Ceci peut paraitre minimaliste mais ce changement de couleur va nous permettre d'adresser le VDP par un test simple.</p>

            <p>
                Pour changer la couleur du bord, nous passerons par la commande indirecte MAT. Notez que l'on se moque bien qu'une commande soit indirecte ou non.<br/>
                Notez aussi que cette commande MAT utilise R1 comme paramètre.
            </p>

            <p>
                <img className="matBorder" src={MatBorder} alt="Mat - border" />
            </p>

            <p>
                Voici un exemple simple afin de changer la couleur :
            </p>

            <p className='code'>
                <pre>
                 0|               LD      A,#21           ;Sélection du registre 1<br/>
                 1|               OUT     (#8F),A<br/>
                 2|               LD      A,%00000111     ;Blanc<br/>
                 3|               OUT     (#CF),A<br/>
                 4|               <br/>
                 5|               LD      A,#28           ;R0+Exe<br/>
                 6|               OUT     (#8F),A<br/>
                 7|               LD      A,%10000010     ;Registre MAT<br/>
                 8|               OUT     (#CF),A
                </pre>
            </p>

            <p>
                Nous commençons donc par mettre la valeur à envoyer à la commande dans R1.<br/>
                Pour selectionner un registre il suffit de faire #20+numéro de registre.<br/>
                On envoie ensuite cette valeur (#21 pour le registre 1) au port de commande (#8F).<br/>
                Le registre est alors selectionné.
            </p>

            <p>
                Une fois notre registre selectionné, nous allons donc lui attribuer sa valeur.<br/>
                Dans notre cas cela sera la couleur.<br/>
                On envoie donc cette valeur au port de données : #CF.
            </p>

            <p>
                Le registre R1 étant chargé avec sa valeur, nous pouvons alors executer la commande MAT.
            </p>

            <p>
                Si vous revenez au chapitre "Commandes de l'EF9345", vous verrez donc que MAT c'est la valeur %10000010.<br/>
                On commencera par demander la selection et l'execution de la commande R0 en envoyant #28 sur le port de commande.
            </p>
            <p>
                #20 comme nous l'avons vu devrait selectionner le registre 0. Mettre le bit 3 à 1 lance en fait l'execution des commandes.<br/>
                Vous pouvez très bien avoir pré-remplis R0 avec son numéro de commande, puis charger par exemple le registre R1 et y ajouter 8 (#29) pour lancer un exe. La seule condition est que R0 contienne bien la commande.
            </p>
            <p>
                Pour executer une commande on passe par R0. Nous mettons donc cette valeur dans celui-ci de la même façon :<br/>
                - On envoie #28 au registre de commande, ce qui demande la selection de R0 mais aussi l'execution de la commande.<br/>
                - On donne la valeur de la commande : %10000010 à R0 en envoyant au port de données, ce qui correspond à la commande MAT.
            </p>


        </div>
    )
}